import React from 'react';
import PropTypes from 'prop-types';

class YoutubeEmbed extends React.Component {
    static get propTypes() {
        return {
            channelId: PropTypes.string,
            watchId: PropTypes.string,
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <iframe frameBorder="0" allowFullScreen={true}
                src={"https://www.youtube.com/embed/"
                    + (this.props.watchId ?? "live_stream") +
                    "?rel=0&showinfo=0&autoplay=1&modestbranding=1&rel=0&mute=1"
                    + (!this.props.watchId ? "&channel=" + this.props.channelId : "")}></iframe>
        );
    }
}

export default YoutubeEmbed;